import { InteractionFilled } from '@ant-design/icons'
import { Button } from '@surecompanies/core_components'
import React, { useState } from 'react'
import { Typography } from '@sureco/design-system'
import RenewalApplicationsModal from '../RenewalApplicationsModal/RenewalApplicationsModal'

export default function RenewalApplicationsButton() {
  /* --------------------------------- States --------------------------------- */
  const [open, setOpen] = useState(false)

  /* ---------------------------------- Doms ---------------------------------- */
  return (
    <>
      <Button
        color="default"
        variant="filled"
        icon={<InteractionFilled />}
        onClick={() => setOpen(true)}
      >
        <Typography>Process Renewals</Typography>
      </Button>
      <RenewalApplicationsModal open={open} onCancel={() => setOpen(false)} />
    </>
  )
}
